module.exports = __webpack_public_path__ + "img/P5181380.03402ac1.jpg";